export const FE_SUPPORT_USER_PROFILES = {
  agent: "AGENT",
  profileUnknown: "PROFILE_UNKNOWN",
  superAgent: "SUPER_AGENT",
} as const;

export type FeSupportUserProfile =
  (typeof FE_SUPPORT_USER_PROFILES)[keyof typeof FE_SUPPORT_USER_PROFILES];

export enum FeSupportUserStatus {
  statusUnknown = "STATUS_UNKNOWN",
  supportUserDisabled = "SUPPORT_USER_DISABLED",
  supportUserEnabled = "SUPPORT_USER_ENABLED",
  supportUserInviting = "SUPPORT_USER_INVITING",
}

export interface FeSupportUser {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  igg?: string;
  jobTitle?: string;
  accountProfile: FeSupportUserProfile;
  status: FeSupportUserStatus;
  createdTs: number | string;
  updatedAt?: number | string;
  hasImpersonateRight?: boolean;
}

export const DEFAULT_SORTABLE_SUPPORT_USER_FIELDS: (keyof FeSupportUser)[] = [
  "id",
];
